import { Avatar, Divider, IconButton, Popover } from '@mui/material';
import { CircleThreeDotsPopover } from 'Images';
import React, { useState } from 'react';
import { Information } from './Information';
import { Actions } from './Actions';
import { RedirectNote } from './RedirectNote';
import { IExtendedDocument } from 'Context/DocumentsContext';

interface IMoreInfoAndAction {
  data: IExtendedDocument;
}

export const MoreInfoAndAction = ({ data }: IMoreInfoAndAction) => {
  const [isPopoverOpen, setMediaPopoverOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const openMediaPopoverHandler = (event: React.MouseEvent) => {
    setAnchorEl(event.currentTarget as Element);
    setMediaPopoverOpen(!isPopoverOpen);
  };

  return (
    <IconButton
      onClick={openMediaPopoverHandler}
      aria-haspopup={true}
      aria-label={``}
      sx={{
        p: 0,
        ':hover': {},
      }}
    >
      <Avatar
        alt=''
        src={CircleThreeDotsPopover}
        sx={{
          width: '30px',
          height: '30px',
        }}
      />
      <Popover
        open={isPopoverOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            width: '392px',
            p: '24px 24px 40px 24px',
            boxShadow: 'none',
            border: '1px solid #F4E4FF',
            borderRadius: '16px',
          },
          onClick: (e: React.MouseEvent) => {
            e.stopPropagation();
          },
        }}
        aria-live='assertive'
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Escape') {
            setMediaPopoverOpen(false);
            setAnchorEl(null);
          }
        }}
      >
        <Information
          isSentToUser={data.isSentToUser}
          docDate={data.documentDate}
          docRequestNumber={data.requestNumber}
          docLinkedRequestNumbers={data.linkedRequestNumbers}
          documentSubject={data.documentSubject}
        />
        <Divider sx={{ borderColor: '#C6CAD4', m: '20px 0' }} />
        <Actions docId={data.id} docType={data.typeId} docName={data.name} />
        <RedirectNote
          infoDescription={data.infoDescription}
          infoLinkText={data.infoLinkText}
          infoLink={data.infoLink}
        />
      </Popover>
    </IconButton>
  );
};
